import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { toAbsoluteUrl } from "../../../_helpers";
import axios from "axios";
import { BASE_URL, NODE_API_URL } from "../../../../env_config";
import { Logoutuser } from "../../controls/Logoutuser";

export const LazyImageComponent = (props) => {

    function handelDetails(row) {
        const elementId = props?.data?.stockID;
        sessionStorage.setItem('scrollToId', elementId); // store ID


       props.setDetailView(props?.data)
       props.setDiamondSelected([props?.data])
    //    const StoreLogs = (expanddata) => {
        let data = {
            stockID: props?.data?.stockID,
            search_id: props?.data?.search_id,
            activity_type:"EXPAND"
        }
        axios({
            method: "POST",
            url: `${NODE_API_URL}/SUPP/store-detail-expand-logs`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("authToken")}`
            },
            data: data
        }).then((res) => {
            
        }).catch((error) => {
            // console.log(error, "ERROR");
            if (error?.response?.data?.message === "UnAuthorized!") {
                Logoutuser();
            }
        });
    // }
    }

    return (
        <>
            {props.data.image ? <div>
                <LazyLoadImage
                    className="img-fluid cursor-pointer"
                    src={props.data.image}
                    alt={props.data.shape}
                    onClick={()=>handelDetails(props)}
                    onError={e => {
                        e.currentTarget.src = toAbsoluteUrl(
                            `/media/shape/${props.data.shape.toLowerCase()}-no.png`
                        )
                    }}
                    effect="blur"
                />
            </div> : <div>
                <img
                    className="img-fluid cursor-pointer"
                    alt="shape"
                    src={toAbsoluteUrl(
                        `/media/shape/${props.data.shape.toLowerCase()}-no.png`
                    )}
                    onClick={()=>handelDetails(props)}
                    onError={e => {
                        e.currentTarget.src = toAbsoluteUrl(
                            `/media/General/NoDiamondImage.svg`
                        )
                    }}
                />
            </div>}
        </>
    );
};
